import { useState } from "react";

import { usePageRestored } from "lib/auth/usePageRestored";

export type ProviderRedirectStatus = "idle" | "starting" | "failed";

/**
 * Tracks a hand-off to an identity provider. "starting" stays set on success so the form doesn't
 * flash back before the browser leaves.
 */
export function useProviderRedirect(initiallyStarting = false) {
  const [status, setStatus] = useState<ProviderRedirectStatus>(
    initiallyStarting ? "starting" : "idle",
  );
  // Back from the provider restores the page with the hand-off still marked in flight.
  usePageRestored(() => setStatus("idle"));

  const start = async (handOff: () => Promise<void>) => {
    setStatus("starting");
    try {
      await handOff();
    } catch {
      setStatus("failed");
    }
  };

  const clearError = () => setStatus((current) => (current === "failed" ? "idle" : current));

  return { status, start, clearError };
}
